<template>
    <div class="applePay">
        <div v-if="canMakePayment" id="payment-request-button"></div>
    </div>
</template>

<script>
import { Form } from "vform";
export default {
    props: {
        amount: {
            required: true,
        },
        currency: {
            required: true,
        },
    },
    created() {
        var country;

        if (this.$website.id == 98) {
            //gamedayseats.co.za
            country = "CA";
        } else {
            country = this.currency.substring(0, 2).toUpperCase();
        }

        // To see how Apple pay using Stripe is integrated visit https://www.youtube.com/watch?v=5KcdQboA7Gc

        var paymentRequest = window.stripe.paymentRequest({
            currency: this.currency.toLowerCase(),
            country: country,
            requestPayerName: true,
            requestPayerEmail: true,
            total: {
                label: this.$website.name,
                amount: this.amount,
            },
        });

        const elements = window.stripe.elements();
        const prButton = elements.create("paymentRequestButton", {
            paymentRequest: paymentRequest,
        });

        paymentRequest.canMakePayment().then((result) => {
            if (result) {
                //Mount the elements
                prButton.mount("#payment-request-button");
            } else {
                this.canMakePayment = false;
            }
        });

        paymentRequest.on("paymentmethod", async (e) => {
            // Create a payment intent

            this.form.get("/booking/stripe/intent").then((clientSecret) => {

                // Confirm the card payment
                window.stripe
                    .confirmCardPayment(
                        clientSecret.data.intent.client_secret,
                        {
                            payment_method: e.paymentMethod.id,
                        },
                        {
                            handleActions: false,
                        }
                    )
                    .then((response) => {
                        if (response.error) {
                            e.complete("fail");
                            return;
                        }
                        e.complete("success");
                        if (
                            response.paymentIntent.status === "requires_action"
                        ) {
                            window.stripe
                                .confirmCardPayment(clientSecret)
                                .then((response) => {
                                    if (response.error) {
                                        alert(response.error.message);
                                        return;
                                    }
                                    this.$emit("applePayComplete");
                                });
                        } else {
                            this.$emit("applePayComplete");
                        }
                    });
            });
        });
    },
    data() {
        return {
            canMakePayment: true,
            form: new Form(),
        };
    },
};
</script>

<style lang="scss" scoped>
#payment-request-button {
    padding: 0px;
    margin-bottom: 15px;
    margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// resources/js/components/Checkout/Gateway/ApplePay.vue